export const appVersion = '0cc07b7';
